$(function() {
	
  $('.collection-products-list figure > a').hover(
    function() {
      if($(this).parents('figure').find('img').length > 1) {
        $(this)
          .parents('figure')
          .find('img:first')
          .hide()
          .next('img')
          .show()
        ;
      }
    }, 
    function() {
      if($(this).parents('figure').find('img').length > 1) {
        $(this)
          .parents('figure')
          .find('img:last')
          .hide()
          .prev('img')
          .show();
        ;
      }
    }
  );
  
});